import { EngagementWidget } from "@/components/specific/engagement";
import { MaintenanceSection, MaintenanceSectionContent, MaintenanceSectionHeader } from "@/components/layout/maintenance";

export const EngagementPage = () => {
  return (
    <MaintenanceSection>
      <MaintenanceSectionHeader
        title="Engagement"
        subtitle="View and track engagement activity and insights across your business."
        noMargin
      />
      <MaintenanceSectionContent>
        <EngagementWidget filters={{}} />
      </MaintenanceSectionContent>
    </MaintenanceSection>
  );
};
